import { useCallback } from "react";

import {
  UI_MODULE_SPECIFICATIONS,
  UI_MOLECULE_FOOTER_MAIN,
} from "../../_common/modules/Data/static";
import { useDataContext } from "../../_common/modules/Data/DataProvider";
import { PAGE_SPECIFICATIONS } from "../../_common/modules/fe-modules/Router/static";
import useCMSPageData from "../../_common/hooks/useCMSPageData";

export type UseSpecificationsProps = {
  headerContent: any;
  mainContent: any;
  footerContent: any;
};

const useSpecifications = (): UseSpecificationsProps => {
  const { data } = useCMSPageData({
    page: PAGE_SPECIFICATIONS,
    queryKey: "specificationsPage",
  });
  const { modalState, gradeSpecificationsList } = useDataContext();

  // ********************
  // Data
  // ********************
  const getHeaderContent = useCallback(() => data?.containers?.header, [data]);

  const getMainContent = useCallback(() => {
    const mainContent = data?.containers?.main;
    if (!mainContent) return mainContent;

    // Inject gradeSpecificationsList from modal data into UiMSpecifications components
    const modalGradeSpecificationsList =
      modalState.data?.gradeSpecificationsList || gradeSpecificationsList;

    return mainContent.map((component: any) => {
      if (component.type === UI_MODULE_SPECIFICATIONS && modalGradeSpecificationsList) {
        return {
          ...component,
          props: {
            ...component.props,
            gradeSpecificationsList: modalGradeSpecificationsList,
          },
        };
      }
      return component;
    });
  }, [data, modalState.data, gradeSpecificationsList]);

  const getFooterContent = useCallback(
    () =>
      data?.containers?.footer.map((component: any) => {
        if (component.type === UI_MOLECULE_FOOTER_MAIN) {
          return {
            ...component,
            props: {
              ...component.props,
              disclaimers: {
                ...component.props?.disclaimers[0]?.props,
                items: component.props?.disclaimers[0]?.props?.items.map((item: any) => ({
                  ...item.props,
                })),
              },
              showBrandIcons: false,
            },
          };
        }
        return component;
      }),
    [data?.containers.footer],
  );

  return {
    headerContent: getHeaderContent(),
    mainContent: getMainContent(),
    footerContent: getFooterContent(),
  };
};

export default useSpecifications;
